(function () {
  function initReviewsScroller(root) {
    var scope = root || document;
    var viewports = scope.querySelectorAll('.sd-reviews__viewport');

    viewports.forEach(function (viewport) {
      if (viewport.dataset.sdReviewsScroller === 'true') {
        return;
      }

      viewport.dataset.sdReviewsScroller = 'true';

      var isDragging = false;
      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var hasDragged = false;
      var dragDirection = null;

      function startDrag(clientX, clientY) {
        isDragging = true;
        hasDragged = false;
        dragDirection = null;
        startX = clientX;
        startY = clientY;
        startScrollLeft = viewport.scrollLeft;
      }

      function moveDrag(clientX, clientY) {
        var deltaX = clientX - startX;
        var deltaY = clientY - startY;

        if (!dragDirection && (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6)) {
          dragDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';

          if (dragDirection === 'horizontal') {
            viewport.classList.add('is-dragging');
          }
        }

        if (dragDirection !== 'horizontal') {
          return;
        }

        if (Math.abs(deltaX) > 3) {
          hasDragged = true;
        }

        viewport.scrollLeft = startScrollLeft - deltaX;
      }

      function stopDrag() {
        if (!isDragging) {
          return;
        }

        isDragging = false;
        dragDirection = null;
        viewport.classList.remove('is-dragging');
      }

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }

        startDrag(event.clientX, event.clientY);
      });

      window.addEventListener('pointermove', function (event) {
        if (!isDragging) {
          return;
        }

        moveDrag(event.clientX, event.clientY);

        if (dragDirection === 'horizontal' && event.cancelable) {
          event.preventDefault();
        }
      });

      window.addEventListener('pointerup', stopDrag);
      window.addEventListener('pointercancel', stopDrag);

      viewport.addEventListener('click', function (event) {
        if (!hasDragged) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReviewsScroller();
    });
  } else {
    initReviewsScroller();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReviewsScroller(event.target);
  });
})();
